// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import CardProfileController from "./card_profile_controller";
application.register("card-profile", CardProfileController);

import CallGroupDestinationsController from "./call_group_destinations_controller";
application.register("call-group-destinations", CallGroupDestinationsController);

import DatepickerController from "./datepicker_controller";
application.register("datepicker", DatepickerController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import EarlyAccessController from "./early_access_controller";
application.register("early-access", EarlyAccessController);

import FormController from "./form_controller";
application.register("form", FormController);

import MenuController from "./menu_controller";
application.register("menu", MenuController);

import PaymentMethodFormController from "./payment_method_form_controller";
application.register("payment-method-form", PaymentMethodFormController);

import PdfController from "./pdf_controller";
application.register("pdf", PdfController);

import TicketController from "./ticket_controller";
application.register("ticket", TicketController);

import AccountSourceController from "./account_source_controller";
application.register("account-source", AccountSourceController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DraftFormController from "./draft_form_controller";
application.register("draft-form", DraftFormController);

import DocumentTaggingController from "./document_tagging_controller";
application.register("document-tagging", DocumentTaggingController);

import ActivityPopupController from "./activity_popup_controller";
application.register("activity-popup", ActivityPopupController);

import ActivityFeedController from "./activity_feed_controller";
application.register("activity-feed", ActivityFeedController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import SelectContactController from "./select_contact_controller";
application.register("select-contact", SelectContactController);

import ContactTicketController from "./contact_ticket_controller";
application.register("contact-ticket", ContactTicketController);

import FeeController from "./fee_controller";
application.register("fee", FeeController);

import RevealController from "./reveal_controller";
application.register("reveal", RevealController);

import TicketExportController from "./ticket_export_controller";
application.register("ticket-export", TicketExportController);

import SenderEmailFormController from "./sender_email_form_controller";
application.register("sender-email-form", SenderEmailFormController);

import RecoveryCodesController from "./recovery_codes_controller";
application.register("recovery-codes", RecoveryCodesController);

import PhoneNumberAdoptionController from "./phone_number_adoption_controller";
application.register("phone-number-adoption", PhoneNumberAdoptionController);

import PhoneNumberTabsController from "./phone_number_tabs_controller";
application.register("phone-number-tabs", PhoneNumberTabsController);

import SamplePlayerController from "./sample_player_controller";
application.register("sample-player", SamplePlayerController);

import WorkflowEditorController from "./workflow_editor_controller";
application.register("workflow-editor", WorkflowEditorController);

import StatsigController from "./statsig_controller";
application.register("statsig", StatsigController);

import StipulationPdfViewer from "./stipulation_pdf_viewer_controller";
application.register("stipulation-pdf-viewer", StipulationPdfViewer);

import DocumentTemplateController from "./document_template_controller";
application.register("document-template", DocumentTemplateController);

import SaveTemplateModalController from "./save_template_modal_controller";
application.register("save-template-modal", SaveTemplateModalController);
